import { createApi } from "@reduxjs/toolkit/query/react";
import { OrderType, Restaurant } from "../../types";
import { RESTAURANT } from "../../configs";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const restaurantApi = createApi({
  reducerPath: RESTAURANT.reducerPath,
  baseQuery: createBaseQuery(RESTAURANT.baseUrl),
  tagTypes: RESTAURANT.tagTypes,
  endpoints(builder) {
    return {
      fetchRestaurantsSuggestions: builder.query<
        Restaurant[],
        { q: string; orderType: OrderType; address: string }
      >({
        query: (params) => {
          return {
            url: "/search/name",
            method: "GET",
            params,
          };
        },
      }),
      fetchNearbyRestaurants: builder.query<
        Restaurant[],
        { q: string; orderType: OrderType }
      >({
        query: ({ q, orderType }) => {
          return {
            url: `/search/address?q=${q}&orderType=${orderType}`,
            method: "GET",
          };
        },
      }),
    };
  },
});

export const {
  useFetchRestaurantsSuggestionsQuery,
  useFetchNearbyRestaurantsQuery,
} = restaurantApi;

export { restaurantApi };
